/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import moment from "moment-timezone";
import { Row, Card, Image, Col } from "react-bootstrap";

export interface IFooterProps {
  brandDetails: {
    brandLogo: string;
    brandLink: string;
    subBrandLogo?: string;
    brandLogoHeight?: any;
    target?: any;
  };
  isFixed?: boolean;
  vlinderDetails: {
    brandLogo: string;
    brandLink: string;
    brandName?: string;
    brandLogoHeight?: any;
    target?: any;
  };
  copyrightTitle: string;
  copyrightStartYear: string;
}

export const Footer = (props: IFooterProps) => {
  const currentYear = moment().get("year");
  return (
    <div style={{ marginBottom: "20px" }}>
      {/* <footer className="fixed-footer d-flex bg-white justify-content-center rounded shadow p-2"> */}
      <footer
        className={`d-flex bg-white justify-content-center rounded shadow p-2 ${
          props.isFixed !== false ? "fixed-footer" : "nonfixed-footer"
        }`}
      >
        <Row>
          <Card.Link
            href={props?.brandDetails?.brandLink}
            target={props?.brandDetails?.target ?? "_blank"}
            className="d-flex justify-content-center"
            style={{ marginBottom: "-15px" }}
          >
            <Image
              src={props?.brandDetails?.brandLogo}
              height={props?.brandDetails?.brandLogoHeight ?? 25}
              className="d-block mb-2"
            />
            <p
              style={{
                fontSize: "12px",
                marginLeft: "0.5%",
                marginRight: "0.5%",
              }}
              className="text-center font-weight-normal font-small mt-2"
            >
              by
            </p>
            <a href={props?.brandDetails?.brandLink} target="_blank">
              <Image
                src={props?.brandDetails?.subBrandLogo}
                height={props?.vlinderDetails?.brandLogoHeight ?? 25}
                style={{ marginTop: "4px" }}
                className="d-block mb-2"
              />
            </a>
          </Card.Link>
          <Col>
            <p className="mb-0 text-center font-weight-normal font-small">
              Copyright © {`${props.copyrightStartYear}-${currentYear}`}.
              Powered by{" "}
              <a
                href={props?.vlinderDetails?.brandLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props?.vlinderDetails?.brandName}
              </a>
              <a
                href={props?.vlinderDetails?.brandLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={props?.vlinderDetails?.brandLogo}
                  height={props?.vlinderDetails?.brandLogoHeight ?? 40}
                  style={{ padding: "5px", marginTop: "-7px" }}
                />
              </a>
            </p>
          </Col>
        </Row>
      </footer>
      <style jsx>{`
        .fixed-footer {
          position: fixed;
          bottom: 20px;
          width: 90%;
          z-index: 1000;
        }
        .nonfixed-footer {
          bottom: 20px;
        }
      `}</style>
    </div>
  );
};

Footer.defaultProps = {};
